import React, { useRef, useState, useEffect } from "react";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import HorizontalPositionSettings from "fantastic/components/common/controls/background/HorizontalPositionSettings";
import { compose } from "redux";
import { debounce } from 'throttle-debounce';
import { useDebouncedEffect  } from 'shared/lib/debounce';

import connectActions from "fantastic/lib/connectActions";
import settingable from "fantastic/components/hoc/settingable";
import actions from "fantastic/actions";

import DeterminateThumbnail from "fantastic/lib/DeterminateThumbnail";

const VideoSettings = ({
  selected,
  update,
  determinatingAction,
  failedAction,
  selectedNode
  // selectedNode: { id, src, href, alt, text_align, meta }
}) => {

  const [hrefValue, setHrefValue] = useState(selectedNode.href);

  useEffect(() => { setHrefValue(selectedNode.href) }, [selectedNode.href] )

  const determinate = (value) => {
    console.log('determinating', value)
  }

  const debouncedDeterminate = useRef(debounce(500, determinate)).current;

  useDebouncedEffect(() => {
    if(hrefValue == selectedNode.href) return;

    update(selected, { href: hrefValue })

    if (!hrefValue.trim()) return;

    determinatingAction(selected, true);
    new DeterminateThumbnail(hrefValue,
      ({ url, title }) => {
        update(selected, { src: url, alt: title })
        determinatingAction(selected, false);
      }, (message) => {
        failedAction(message || i18n.t('video.error'))
        determinatingAction(selected, false);
      });

    return () => {
      if(meta.determinate) return;

      determinating(false);
    }
  }, 500, [hrefValue]);

  const VIDEO_URL_PATTERN = /^https?:\/\/(www\.)?(youtube\.com|youtu\.be|vimeo\.com|rutube\.ru|vk\.com|vkvideo\.ru)/i;

  const handleChangeHref = (value) => setHrefValue(value);
  const handleChangeAlt = (value) => update(selected, { alt: value });
  const handleChangeSrc = (value) => {
    if (VIDEO_URL_PATTERN.test(value.trim())) {
      setHrefValue(value.trim());
    } else {
      update(selected, { src: value });
    }
  };

  return (
    <div>
      <SingleStringSetting value={hrefValue}
                           onChange={handleChangeHref}
                           label={i18n.t('video.label')}
                           placeholder={i18n.t('video.enter')}
                           disabled={selectedNode.meta.determinate} />
      <SingleStringSetting value={selectedNode.alt}
                           onChange={handleChangeAlt}
                           label="Alt"
                           disabled={selectedNode.meta.determinate} />
      { selectedNode.src &&
        <div className="form-group">
          <label>{ i18n.t('text_align') }</label>
          <div>
            <HorizontalPositionSettings
              onChange={(_field, value) => update(selected, { text_align: value })}
              position={{ field: 'text_align', value: selectedNode.text_align || 'left' }}
            />
          </div>
        </div>
      }
      <SingleStringSetting value={selectedNode.src}
                           onChange={handleChangeSrc}
                           label={i18n.t('video.src')}
                           placeholder={i18n.t('video.src_placeholder')}
                           disabled={selectedNode.meta.determinate} />
    </div>
  );
};

export default compose(
  settingable("padding", "visibility"),
  connectActions({
    update: actions.updateNode,
    determinatingAction: (id, determinate) => (dispatch) => dispatch({ type: 'SECTIONS/NODE/DETERMINATE', payload: { id, determinate }}),
    failedAction: (payload) => (dispatch) => { dispatch({ type: "FAIL", payload }) }
  })
)(VideoSettings);
